<div class="create-tire-dialog tire-storage">
  <div class="tire-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-tire font-20 font-gray-45 header-icon"></i>
        <div class="pl-1 tire-description width-100p p-relative">
          <p class="m-0 font-secondary-700 font-14" *ngIf="!tireId">Tire storage</p>
          <p class="m-0 font-secondary-700 font-14" *ngIf="tireId">Tire storage - TS# {{tire?.externalId}}</p>
        </div>
        <i class="print-tire-storage-btn pointer font-21" tooltipPosition="top"
          *ngIf="openFrom === 'tire-storage-list' && isEnhancedTSEnabled" [disabled]="isPrintingLabel"
          tooltipStyleClass="font-11" [pTooltip]="'Print tire storage sticker'"
          [ngClass]="{'fal fa-spinner rotate': isPrintingLabel, 'far fa-print' : !isPrintingLabel }"
          (click)="handleTirestoragePrint()"></i>
        <i id="tire-close-dialog" class="far fa-times pointer dialog-close" (click)="handleCloseModal()"></i>
      </div>
    </div>
  </div>


  <!-- Start Add Tire Body -->
  <div class="ui-g tire-body pt-0 pb-0 border-bottom-light">
    <div class="ui-g-12 inputs-column-spacing tire-inner-body" #partBody>

      <!-- Basic Info section -->
      <div *ngIf="isGlobalCategoryEnabled" class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
        <h5 class="input-heading font-14">Basic info</h5>
        <div class="ui-g-12 p-0 input-control-container" *ngIf="!isEnhancedTSEnabled && !isNewCategoriesEnabled">
          <div class="ui-g-6 p-0 flex-start-center">
            <div class="icon flex-center-start">
              <i class="far fa-copyright height-icon"></i>
            </div>

            <div class="width-100p pl-1 pr-2">
              <app-auto-complete placeholder="Brand" label="Brand" scrollHeight="198px" editFieldLabel="Create brand"
                tooltipPosition="top" editableItemIdKey="_id" editFieldPlaceholder="Create brand" [autoFocus]="!tireId"
                [fontSize]="14" [theme]="errors?.brand? 'primary' : 'light'" [floatingLabel]="true"
                [value]="tire?.brand?.name" [isInvalid]="errors?.brand" [hasError]="errors?.brand"
                [listItemFontSize]="14" [isSaveForFuture]="true" [hasFutureSelectionField]="false"
                [isDropdownIconVisible]="true" [suggestions]="tagsSuggestion"
                [disabled]="isDisabled || tire?.isInStorage" [pTooltip]="tireStorageDisabledTooltip"
                [hasEditableField]="true" (appCompletedMethod)="handleTagSearch($event)"
                (appClear)="handleClear('brand')" (appSelect)="handleSelect($event, 'brand')"
                (appSave)="handleCreateBrand($event)" (appUpdateItem)="onUpdateItem($event, 'brand')">
                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center">
                    <div>
                      <span>{{ item?.name }}</span>
                    </div>
                    <div class="tag-item-action flex-end-center">
                      <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
          </div>

          <div class="ui-g-6 p-0 flex-start-center">
            <div class="icon flex-center-start">
              <i class="far fa-tire height-icon"></i>
            </div>
            <div class="tire-category width-100p pl-1 pr-2">
              <app-input placeholder="Model" tooltipPosition="top" [disabled]="isDisabled || tire?.isInStorage"
                [pTooltip]="tireStorageDisabledTooltip" [theme]="errors?.model? 'primary' : 'light'"
                [floatingLabel]="true" [isInvalid]="errors?.model" [value]="tire.model"
                (appChange)="handleChange($event, 'model')" (appBlur)="handleBlur('model')">
              </app-input>
            </div>
          </div>
        </div>
        <div class="ui-g-12 p-0 input-control-container-no-wrap" *ngIf="isNewCategoriesEnabled || isEnhancedTSEnabled">
          <div class="ui-g-4 p-0 flex-start-center" *ngIf="isEnhancedTSEnabled">
            <div class="icon flex-center-start">
              <i class="far fa-ruler height-icon"></i>
            </div>

            <div class="width-100p pl-1 pr-2">
              <app-input tooltipPosition="top" placeholder="Tire Storage name" [disabled]="tire?.isInStorage"
                [pTooltip]="tireStorageDisabledTooltip" [theme]="errors?.title ? 'primary' : 'light'"
                [floatingLabel]="true" [isInvalid]="errors?.title" [errorMessage]="errors?.title" [maxLength]="100"
                [value]="tire.title" (appChange)="handleChange($event, 'title')" (appFocus)="handleFocus('title')"
                (appBlur)="handleBlur('title')"></app-input>
            </div>
          </div>

          <!-- Standard category -->
          <div class="ui-g-4 p-0 flex-start-center" *ngIf="isNewCategoriesEnabled">
            <div class="width-100p pl-1 pr-2" tooltipPosition="top"
              tooltipStyleClass="tooltip-width-medium text-center">
              <app-auto-complete id="standard-category" listId="standard-category-list" field="categoryName"
                label="Standard Category" placeholder="Standard Category" scrollHeight="186px" theme="light"
                [value]="tire?.category?.categoryName" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true"
                [listItemFontSize]="13" [suggestions]="categoriesSuggestionsResults" [isLoading]="loader?.category"
                [disabled]="true" [isDropdownIconVisible]="true" (appFocus)="handleFocus('category')"
                (appBlur)="handleBlur('category')" (appSelect)="categoryDropdownSelect('category', $event)"
                (appCompletedMethod)="onSearchItem('category', $event)"
                (appClear)="handleClear('category')"></app-auto-complete>
            </div>
          </div>

          <!-- Sales code -->
          <div class="ui-g-4 p-0 flex-start-center not-allowed" *ngIf="isNewCategoriesEnabled && isSalesCodeEnabled"
            tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
            [pTooltip]="!canEditClassifications && openFrom !== 'RO' ? classificationPrivilegeMsg : (tire?.salesCode?.title === 'Unassigned' || !tire?.salesCode?.title) ? 'Click here to assign sales code' : ''">

            <div class="tire-category width-100p pl-1 pr-2">
              <app-input id="sales-code" type="text" placeholder="Sales Code" theme="primary" [fontSize]="14"
                name="sales-code" [value]="displaySalesCodeTitle()" [floatingLabel]="true" [maxLength]="50"
                [disabled]="true"
                [rightIcon]="!tire?.salesCode?.shortName ? 'fas fa-plus-circle font-warning pointer' : ''"
                [imgIcon]="tire?.salesCode?.shortName ? 'assets/img/icon/edit-outline.svg' : ''" imgIconClass="pointer"
                (iconClicked)="openAssignSalesCodeDialog()">
              </app-input>
            </div>
          </div>
        </div>
      </div>
      <!-- Basic info section ends -->

      <!-- item classification -->
      <!-- <div *ngIf="isNewCategoriesEnabled" class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
        <h5 class="input-heading font-14">Item classification <span><i class="fas fa-info-circle"></i></span></h5>
        <div class="ui-g-12 p-0 input-control-container" tooltipPosition="top"
          tooltipStyleClass="tooltip-width-medium text-center"
          [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
          <app-category-search subId="1" [type]="'tireStorage'" [placeholder]="'Search category'"
            [canEditClassifications]="canEditClassifications"
            (appSelect)="onSelectCategory($event)"></app-category-search>

        </div>

        <div class="ui-g-12 p-0 input-control-container pt-2">
          <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
            [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
            <app-auto-complete id="standard-category" listId="standard-category-list" field="categoryName"
              label="Standard Category" placeholder="Standard Category" scrollHeight="186px" theme="light"
              [value]="tire?.category?.categoryName" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true"
              [listItemFontSize]="13" [suggestions]="categoriesSuggestionsResults" [isLoading]="loader?.category"
              [disabled]="!canEditClassifications" [isDropdownIconVisible]="true" (appFocus)="handleFocus('category')"
              (appBlur)="handleBlur('category')" (appSelect)="categoryDropdownSelect('category', $event)"
              (appCompletedMethod)="onSearchItem('category', $event)"
              (appClear)="handleClear('category')"></app-auto-complete>
          </div>
          <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
            [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
            <app-auto-complete id="standard-subcategory" listId="standard-subcategory-list" field="subCategoryName"
              label="Standard Subcategory" placeholder="Standard Subcategory" scrollHeight="186px" theme="light"
              [value]="tire.category?.subCategoryName" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true"
              [listItemFontSize]="13" [suggestions]="subCategoriesSuggestionsResults" [isDropdownIconVisible]="true"
              [disabled]="!tire.category?.categoryId || !canEditClassifications" (appFocus)="handleFocus('subCategory')"
              (appBlur)="handleBlur('subCategory')" [isLoading]="loader?.subCategory"
              (appSelect)="categoryDropdownSelect('subCategory', $event)"
              (appCompletedMethod)="onSearchItem('subCategory', $event)"
              (appClear)="handleClear('subCategory')"></app-auto-complete>
          </div>
          <div class="ui-g-4" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
            [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
            <app-auto-complete id="standard-tire-type" listId="standard-tire-type-list" field="subSubCategoryName"
              label="Standard Tire Type" placeholder="Standard Tire Type" scrollHeight="186px" theme="light"
              [value]="tire.category?.subSubCategoryName" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true"
              [listItemFontSize]="13" [disabled]="!tire.category?.subCategoryId || !canEditClassifications"
              [suggestions]="subSubCategoriesSuggestionsResults" [isDropdownIconVisible]="true"
              [isLoading]="loader?.subSubCategory" (appFocus)="handleFocus('subSubCategory')"
              (appBlur)="handleBlur('subSubCategory')" (appSelect)="categoryDropdownSelect('subSubCategory', $event)"
              (appCompletedMethod)="onSearchItem('subSubCategory', $event)"
              (appClear)="handleClear('subSubCategory')"></app-auto-complete>
          </div>
        </div>
      </div> -->
      <!-- item classification end-->

      <!-- Sales Code -->
      <!-- <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0" *ngIf="isNewCategoriesEnabled && isSalesCodeEnabled">

        <div class="ui-g-4 p-0 flex-start-center not-allowed"
          tooltipPosition="top"
          tooltipStyleClass="tooltip-width-medium text-center"
          [pTooltip]="!canEditClassifications && openFrom !== 'RO' ? classificationPrivilegeMsg : (tire?.salesCode?.title === 'Unassigned' || !tire?.salesCode?.title) ? 'Click here to assign sales code' : ''">

          <div class="tire-category width-100p pl-1 pr-2">
            <app-input id="sales-code" type="text" placeholder="Sales Code" theme="primary" [fontSize]="14"
              name="sales-code" [value]="displaySalesCodeTitle()" [floatingLabel]="true" [maxLength]="50"
              [disabled]="true"
              [rightIcon]="!tire?.salesCode?.shortName ? 'fas fa-plus-circle font-warning pointer' : ''"
              [imgIcon]="tire?.salesCode?.shortName ? 'assets/img/icon/edit-outline.svg' : ''"
              imgIconClass="pointer"
              (iconClicked)="openAssignSalesCodeDialog()">
            </app-input>
          </div>
        </div>
      </div> -->

      <!-- Seasonality Info section -->
      <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0" style="margin-bottom: 20px;"
        *ngIf="!isEnhancedTSEnabled">
        <div class="ui-g-12 p-0 input-control-container">
          <div class="ui-g-12 p-0 flex-start-center">
            <div class="icon flex-center-start mt-3">
              <i class="far fa-sun-cloud height-icon"></i>
            </div>

            <div class="width-100p pl-1">
              <h5 class="font-11 font-gray-45 mb-1">Seasonality</h5>
              <div class="ui-g-12 p-0 seasonality-wrapper" tooltipPosition="top" [pTooltip]="tireStorageDisabledTooltip"
                [ngClass]="{'not-allowed': isDisabled}">
                <div class="ui-g-4 p-1 seasonality-tab text-center pointer"
                  [ngClass]="{'active': tire.seasonality === 'summer'}"
                  (click)="isDisabled  || tire?.isInStorage? null : handleChange('summer', 'seasonality')">
                  <i class="far fa-sun font-gray-35"></i>
                  <span class="pl-6p">Summer</span>
                </div>

                <div class="ui-g-4 p-1 seasonality-tab text-center pointer"
                  [ngClass]="{'active': tire.seasonality === 'winter'}"
                  (click)="isDisabled  || tire?.isInStorage? null : handleChange('winter', 'seasonality')">
                  <i class="far fa-cloud-snow font-gray-35"></i>
                  <span class="pl-6p">Winter</span>
                </div>

                <div class="ui-g-4 p-1 seasonality-tab text-center pointer"
                  [ngClass]="{'active': tire.seasonality === 'all'}"
                  (click)="isDisabled || tire?.isInStorage ? null : handleChange('all', 'seasonality')">
                  <i class="far fa-cloud-sun-rain font-gray-35"></i>
                  <span class="pl-6p">All seasons</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Seasonality Info section ends -->

      <!-- Size section -->
      <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0 mt-3">
        <div class="ui-g-12 p-0 input-control-container tire-storage-size">
          <app-tire-size *ngFor="let size of tire.sizes; let sizeIndex = index" tireType="tireStorage"
            [locations]="locations" [isCommissionPlanEnabled]="isCommissionPlanEnabled"
            [isEnhancedTSEnabled]="isEnhancedTSEnabled" [isQboConnected]="isQboConnected"
            [isInStorage]="tire?.isInStorage" [tireStorageDisabledTooltip]="tireStorageDisabledTooltip"
            [isTireStorageList]="isDisabled" [isPartsTechItem]="isDisabled" [isInventoryEnabled]="isInventoryEnabled"
            [tire]="tire" [orderServiceId]="orderServiceId" [errors]="tire?.errors[sizeIndex] || {}"
            [pricings]="pricings" [qboItemRefs]="qboItemRefs" [index]="sizeIndex" [size]="size"
            [defaultQboItemRefs]="defaultQboItemRefs" (appDeleteTireSize)="handleDeleteTireSize($event)">
          </app-tire-size>
        </div>
        <!-- Size section ends-->

        <div class="ui-g-12 p-0 mt-1 d-flex">
          <h5 class="input-heading font-14 mb-0">Tire Storage Information</h5>

          <div class="tire-count-status" *ngIf="!isEnhancedTSEnabled">
            <span *ngIf="tire && tire.tiresInfo && tire.tiresInfo.length !== 0">
              <span *ngIf="tire.tiresInfo && tire.tiresInfo.length > 1">
                {{tire.tiresInfo.length}} tires added
              </span>

              <span *ngIf="tire.tiresInfo && tire.tiresInfo.length == 1">
                {{tire.tiresInfo.length}} tire added
              </span>
            </span>

            <span *ngIf="!tire?.tiresInfo?.length">No tires added</span>
          </div>

          <span *ngIf="tire?.tiresInfo?.length < 6 && !tire?.isInStorage && !isEnhancedTSEnabled" class="pointer"
            (click)="handleAddTireInfo()">
            <i class="far fa-plus-circle"></i></span>
        </div>

        <div class="ui-g-12 p-0 mt-0">
          <div class="tech-detail">Details to be added by technician</div>
        </div>

        <div class="ui-g-12 p-0 input-control-container mt-3">
          <app-tire-storage-info *ngFor="let tireInfo of tire.tiresInfo; let sizeIndex = index" [locations]="locations"
            [categories]="categories" [isDisabled]="isDisabled || tire?.isInStorage"
            [tireStorageDisabledTooltip]="tireStorageDisabledTooltip"
            [disabledDuplicate]="disabledDuplicate || isLoading"
            [lowerTreadDepthThreshold]="data?.lowerTreadDepthThreshold" [rimTypes]="rimTypes" [tire]="tire"
            [index]="sizeIndex" [size]="tireInfo" [errors]="tireInfo?.errors || {}" [openFrom]="openFrom"
            [isEnhancedTSEnabled]="isEnhancedTSEnabled" [sesonalityOptions]="seasonalityOption"
            [tirePositionOptions]="tirePositionOptions" [estimateOrderStatus]="estimateOrderStatus"
            (appCreateBrand)="handleCreateBrand($event)" (appOnUpdateItem)="onUpdateItem($event?.data, $event?.type)"
            (appDuplicateTireStorageSize)="handleAddTireInfo($event)"
            (appDeleteTireStorageSize)="handleDeleteStorageTire($event)" (appUpdateLocations)="updateLocations($event)">
          </app-tire-storage-info>
        </div>
        <div class="ui-g-12 p-0 input-control-container" *ngIf="isEnhancedTSEnabled">
          <button *ngIf="tire?.tiresInfo?.length < 6 && !tire?.isInStorage" [hidden]="isLoading"
            (click)="handleAddTireInfo(defaultTireInfo)" class="btn btn-block btn-primary-light">
            <span class="font-16 font-700">
              <i class="far fa-plus-circle font-900 tire-storage-Enhanced-btn"></i>
              Add Tire
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Start Add Tire Body ends -->

  <!-- Start Add Parts Footer -->
  <div class="ui-g-12 flex-between-center dialog-footer part-footer p-0">
    <div class="create-tire-dialog-footer d-flex justify-content-between width-100p">
      <div>
      </div>

      <div>
        <button class="btn btn-border pointer btn-submit mr-1" (click)="handleCloseModal()">Cancel</button>
        <button class="btn btn-primary btn-submit" tooltipPosition="top"
          [pTooltip]="isLockedRO ? 'Sorry, cannot make any changes to a Locked RO':isFinalizedRo ? 'Sorry, cannot make any changes to a finalized RO' : ''"
          [disabled]="isProcessing || isLoading || isFinalizedRo || isLockedRO" (click)="handleSubmit()">
          <span [ngClass]="{'pr-2': isProcessing}">Save</span>
          <i *ngIf="isProcessing" class="far fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>
  <!-- End Add Parts Footer -->
</div>
